<template>
  <div class="ma-3">
    <v-toolbar class="mb-3" height="30px" color="#425058" dark>
      <h4>Audit Logs</h4>
    </v-toolbar>
    <v-spacer></v-spacer>
    <v-data-table
      :headers="headers"
      :items="audits"
      :sort-by="['created']"
      :sort-desc="[true]"
      style="cursor: pointer"
      dense
      :items-per-page="20"
      :loading="dataLoading"
      loading-text="Loading... Please wait"
      :search="search"
    >
      <template v-slot:top>
        <v-row class="pa-2 ma-2 align-center">
        <v-text-field class="search-bar"
            small
            dense
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            hint="Search any of the columns below...."
          ></v-text-field>
          <v-btn
            v-for="btn in filterBtns"
            :key="btn.text"
            :color="btn.selected === true ? 'success' : ''"
            dense
            small
            elevation="2"
            class="mr-3"
            @click="onFilterBtnClick(btn)"
            >{{ btn.text }}</v-btn
          >
          <v-menu
            v-model="showDatePicker"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateRangeText"
                prepend-icon="mdi-calendar"
                readonly
                dense
                outlined
                hide-details
                color="success darken-2"
                v-bind="attrs"
                v-on="on"
                style="max-width: 300px"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dates"
              no-title
              scrollable
              range
              :allowed-dates="allowedDates"
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="showDatePicker = false">
                Cancel
              </v-btn>
              <v-btn text color="primary" @click="onDatesConfirm"> OK </v-btn>
            </v-date-picker>
          </v-menu>
          
        </v-row>
      </template>
      <template v-slot:[`item.details`]="{ item }">
        <v-tooltip right color="success">
          <template v-slot:activator="{ on, attrs }">
            <span  v-bind="attrs"
          v-on="on">{{ item.details }}</span>
          </template>
          <pre>{{ tryParseJson(item.details) }}</pre>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { add } from "date-fns";

export default {
  data() {
    return {
      dataLoading: false,
      dates: [],
      showDatePicker: false,
      filterBtns: [
        
      ],
      search: "",
      headers: [
        {
          text: "Action",
          value: "action",
        },
        {
          text: "Description",
          value: "description",
        },
        {
          text: "Details",
          value: "details",
          width: "30%"
        },
        {
          text: "User",
          value: "userID",
        },

        {
          text: "Date Time",
          value: "created",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("audit", ["getAudits"]),
    audits() {
      return this.getAudits;
    },
    dateRangeText() {
      return this.dates.join(" ~ ");
    },
  },
  methods: {
    ...mapActions("audit", ["fetchAudits"]),

    async refreshAudits(filter) {
      this.dataLoading = true;
      await this.fetchAudits(filter);
      this.dataLoading = false;
    },
    onFilterBtnClick(btn) {
      this.filterBtns.forEach((b) => {
        b.selected = btn.text == b.text ? true : false;
      });
      this.dates = [];
      this.refreshAudits(btn.filter());
    },
    onDatesConfirm() {
      this.showDatePicker = false;
      let btn = this.filterBtns.find((b) => b.selected);
      if (btn) {
        btn.selected = false;
      }
      const localStartTime = new Date(this.dates[0])
      const localEndTime = new Date(this.dates[1])
      this.refreshAudits({
        startTime: new Date(localStartTime.getTime()+localStartTime.getTimezoneOffset()*60000),
        endTime: add(new Date(localEndTime.getTime()+localEndTime.getTimezoneOffset()*60000),{ days: 1}),
      });
    },
    tryParseJson(str) {
      try{
        return JSON.stringify(JSON.parse(str), null, 2)
      }
      catch(e){
        return str
      }
    },
    allowedDates(date) {
      const currentDate = new Date(date)
      return Date.now() >= (currentDate.getTime() + currentDate.getTimezoneOffset()*60000);
    },
  },
  async mounted() {
      this.filterBtns =[{
          text: "Today",
          selected: true,
          filter: () => {
            const now = new Date();
            return {
              startTime: new Date(
                now.getFullYear(),
                  now.getMonth(),
                  now.getDate() 
              ),
            };
          },
        },
        {
          text: "Last 7 Days",
          selected: false,
          filter: () => {
            const now = new Date();
            return {
              startTime: add(
                new Date(
                  now.getFullYear(),
                  now.getMonth(),
                  now.getDate() 
                ),
                { days: -7 }
              ),
            };
          },
        },
        {
          text: "Last 30 Days",
          selected: false,
          filter: () => {
            const now = new Date();
            return {
              startTime: add(
                new Date(
                  now.getFullYear(),
                  now.getMonth(),
                  now.getDate() 
                ),
                { days: -30 }
              ),
            };
          },
        },]
    await this.refreshAudits(this.filterBtns[0].filter());
  },
};
</script>

<style scoped>
.search-bar{
    max-width: 400px;
    margin-right: 20px;
    margin-top: 18px
}
</style>
